<svg
    width="301"
    height="220"
    viewBox="0 0 301 220"
    xmlns="http://www.w3.org/2000/svg">
    <g
        app-roof
        [type]="type()"></g>
    <g
        [x]="-90"
        [y]="10"
        app-roof-box></g>
    <g
        [x]="-30"
        [y]="-30"
        app-roof-box></g>
    <g
        [width]="250"
        [height]="250"
        [x]="130"
        [y]="-10"
        app-roof-vent></g>
    <g
        [width]="250"
        [height]="250"
        [x]="85"
        [y]="20"
        app-roof-vent></g>
</svg>
